import { render, staticRenderFns } from "./ShopCategoriesReorder.vue?vue&type=template&id=6c34723a"
import script from "./ShopCategoriesReorder.vue?vue&type=script&lang=js"
export * from "./ShopCategoriesReorder.vue?vue&type=script&lang=js"
import style0 from "./ShopCategoriesReorder.vue?vue&type=style&index=0&id=6c34723a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
